import { Component, OnInit } from '@angular/core';
import { CtaService } from "../../_services/cta.service";

@Component({
  selector: 'bxl-event-software',
  templateUrl: 'event-software.component.html',
})
export class EventSoftwareComponent implements OnInit {
  initialized = false;
  constructor(public ctaService:CtaService) { }

  ngOnInit(): void {
    this.initialized = true;
  }
}
